enum EntityImageSizeEnum {
  Source = 1,
  Small300,
  Medium600,
  Large1000,
}

export default EntityImageSizeEnum;
